import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, CircularProgress, IconButton, Stack, type SxProps, Typography } from "@mui/material";
import { useState } from "react";
import Block from "./Block";

export default function Section({
  children,
  collapsible = false,
  title,
  defaultOpen = false,
  footer,
  loading = false,
  sx,
}: {
  children?: React.ReactNode;
  collapsible?: boolean;
  title?: string;
  defaultOpen?: boolean;
  footer?: React.ReactNode;
  loading?: boolean;
  sx?: SxProps;
}) {
  const [open, setOpen] = useState(collapsible ? defaultOpen : true);
  return (
    <Block
      sx={{
        position: "relative",
        opacity: loading ? 0.5 : 1,
        ...sx,
      }}
    >
      {loading && (
        <CircularProgress
          size={16}
          sx={{ position: "absolute", top: "50%", left: "50%", zIndex: 1 }}
        />
      )}
      {(title || collapsible) && (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            mb: 2,
          }}
        >
          {title && <Typography variant="h3">{title}</Typography>}
          {collapsible && (
            <IconButton onClick={() => setOpen(!open)}>
              <ExpandMoreIcon sx={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }} />
            </IconButton>
          )}
        </Stack>
      )}
      {open && children}
      {footer && <Box sx={{ mt: 2 }}>{footer}</Box>}
    </Block>
  );
}
